import { PcApiResponse } from '@/api/pc-api/types';
import { BizType } from '@/constants/bizType';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

type DefaultPartnerDetailsInfo = {
  id: string;
  companyName: string;
  businessNumber: string;
  representativeName: string;
};

type PartnerDetailsInfo1 = {
  bizType: BizType.MYDATA_CORP | BizType.MYDATA_PROVIDER;
} & DefaultPartnerDetailsInfo;

type PartnerDetailsInfo2 = {
  bizType: BizType.SET4 | BizType.EDOC;
  appId: number;
  appName: string;
} & DefaultPartnerDetailsInfo;

export type PartnerDetailsInfo = PartnerDetailsInfo1 | PartnerDetailsInfo2;
export const getPartnerDetailsInfo = (partnerId: string) => {
  return api<PcApiResponse<PartnerDetailsInfo>>('get', `/pc-api/v1/${PREFIX_PATH}/partner/details/info`, {
    partnerId
  });
};
